import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/inputnumber/inputnumberview
 */
import InputView from '../input/inputview.js';
/**
 * The number input view class.
 */
var InputNumberView = /*#__PURE__*/function (_InputView) {
  _inherits(InputNumberView, _InputView);
  var _super = _createSuper(InputNumberView);
  /**
   * Creates an instance of the input number view.
   *
   * @param locale The {@link module:core/editor/editor~Editor#locale} instance.
   * @param options The options of the input.
   * @param options.min The value of the `min` DOM attribute (the lowest accepted value).
   * @param options.max The value of the `max` DOM attribute (the highest accepted value).
   * @param options.step The value of the `step` DOM attribute.
   */
  function InputNumberView(locale) {
    var _this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      min = _ref.min,
      max = _ref.max,
      step = _ref.step;
    _classCallCheck(this, InputNumberView);
    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    _this.set('min', min);
    _this.set('max', max);
    _this.set('step', step);
    _this.extendTemplate({
      attributes: {
        type: 'number',
        class: ['ck-input-number'],
        min: bind.to('min'),
        max: bind.to('max'),
        step: bind.to('step')
      }
    });
    return _this;
  }
  return InputNumberView;
}(InputView);
export { InputNumberView as default };